import { MerchantAppointmentQueueDto } from "@/models/club";
import { isSuccessfulAppointmentPayment } from "@/services/payment/appointmentPaymentStatus";

export const hasUserPayment = (appointment: MerchantAppointmentQueueDto) =>
  isSuccessfulAppointmentPayment(appointment);